module.exports = __webpack_public_path__ + "img/logo_white.9701e5a1.png";